import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const DownloadCaseContentWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 44px 0;
`;

export const StyledTitle = styled(Typography.TextH1_36_52)(
    ({ theme: { fontSize } }) => css`
        text-align: center;
        margin: 0 0 16px;

        @media (max-width: ${breakpoints.md}px) {
            font-size: ${fontSize[28]}px;
            line-height: 40px;
        }
    `,
);

export const StyledText = styled(Typography.TextBody_16_24)`
    margin-bottom: 40px;
`;
